const INITIAL_STATE = {
  data: {},
  errors: {},
}
    
const getMessageCount = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'MESSAGE_COUNT':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'MESSAGE_COUNT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
    
export default getMessageCount;